import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-5 ">
      <div className="row container mx-auto pt-5" style={{ display: "flex" }}>
        <div className="footer-one col-lg-3 col-md-6 col-12">
          <img width="100px" height="50px" src="/img/logoo.png" alt="" />
          <p className="pt-3">
            Pure Nature in Every Bite. Naturiko one of the trusted place to buy
            natural healthy foods. committed to provide 100% original & halal
            food. Our 1st priority is good quality food also your satisfaction.
          </p>
        </div>

        <div className="footer-one col-lg-3 col-md-6 col-12 mb-3">
          <h5 className="pb-2">Quick Links</h5>

          <ul className="text-uppercase list-unstyled">
            <li>
              <Link>About Us</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
            <li>
              <Link to="/dashboard">Dashboard</Link>
            </li>
            {/* <li>
              <Link
                target="_blank"
                to="https://naturiko.com/server/admin/login/?next=/server/admin/"
              >
                DjanGo
              </Link>
            </li> */}
          </ul>
        </div>

        <div className="footer-one col-lg-3 col-md-6 col-12 mb-3">
          <h5 className="pb-2">Information</h5>

          <ul className="text-uppercase list-unstyled">
            <li>
              <Link>How to order</Link>
            </li>
            <li>
              <Link>Return Policy</Link>
            </li>
            <li>
              <Link>Shipment</Link>
            </li>
          </ul>
        </div>

        <div className="footer-one col-lg-3 col-md-6 col-12">
          <h5 className="pb-2">Follow Us</h5>

          <div className="icon">
            <Link target="_blank" to="https://www.facebook.com/Naturikobd">
              <i className="fab fa-facebook-f"></i>
            </Link>
            <Link
              target="_blank"
              to="https://www.instagram.com/naturiko_shop/?hl=en"
            >
              <i className="fab fa-instagram"></i>
            </Link>
            <Link>
              <i className="fab fa-linkedin-in"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="my-3">
        <img width="100%" height="auto" src="img/ssl.png" alt="" />
      </div>

      <div className="copyright ">
        <div className="row container mx-auto">
          <p className="my-3 text-center">
            &copy;{currentYear}.Naturiko, Design & Develop by{" "}
            <Link
              target="_blank"
              style={{ textDecoration: "none", color: "red" }}
              to="http://www.ekattorit.com/"
            >
              EKATTOR <span style={{ color: "green" }}>iT</span>
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
